import { put,select } from 'redux-saga/effects'
import importer from 'common/importer'
/* ACTIONS */
const UserActions = importer('Stores/Users/Actions')
const { tokens } = importer('Stores/Users/Select', null)

import loginWithProxyPdn from '../../../APIs/auth/deloit/LoginWithProxyPdn'

export default function * main ({ proxyPdn }) {

  const _tokens = yield select(tokens)
  const { token_type, id_token } = _tokens
  const token = `${token_type} ${id_token}`
  try {
    yield put(UserActions.loginWithProxyPdnLoading())

      let loginWithProxyPdnRes = yield loginWithProxyPdn({token,proxyPdn})

      if (loginWithProxyPdnRes.status === 200 && loginWithProxyPdnRes.data) {
        yield put(UserActions.loginWithProxyPdnSuccess(loginWithProxyPdnRes.data))
      } else {
        throw Error(oktaLogin)
      }


  } catch (error) {
    yield put(UserActions.loginWithProxyPdnFailure(error))
  }
}